import axios from 'axios'
import WebSocketService from './websocketService'
import { getApiUrl, getDefaultHeaders } from '@/config/env'

// Criar instância do Axios com configuração base
const api = axios.create({
  baseURL: getApiUrl(),
  timeout: 300000, // 5 minutos de timeout (aumentado de 30 segundos)
  headers: getDefaultHeaders()
})

// Interceptor para logging de requisições e adicionar token
api.interceptors.request.use(config => {
  // Log apenas para erros ou em desenvolvimento
  if (process.env.NODE_ENV === 'development' && config.url.includes('/error')) {
    console.debug(`[API] ${config.method.toUpperCase()} ${config.url}`)
  }
  
  // Adicionar token de autenticação
  const token = localStorage.getItem('authToken')
  if (token && !config.url.includes('/auth/login')) {
    config.headers.Authorization = `Bearer ${token}`
  }
  
  return config
}, error => {
  console.error('[API] Erro na requisição:', error)
  return Promise.reject(error)
})

// Interceptor para tratamento de respostas
api.interceptors.response.use(
  response => {
    // Log apenas para erros ou em desenvolvimento
    if (process.env.NODE_ENV === 'development' && response.status >= 400) {
      console.debug(`[API] Resposta ${response.status}: ${response.config.method.toUpperCase()} ${response.config.url}`)
    }
    return response.data
  },
  error => {
    // Processar erro
    const statusCode = error.response ? error.response.status : 0
    const errorMessage = error.response && error.response.data && error.response.data.message
      ? error.response.data.message
      : error.message
    
    // Log do erro
    console.error(`[API] Erro ${statusCode}: ${errorMessage}`, {
      url: error.config.url,
      method: error.config.method,
      data: error.config.data,
      status: statusCode
    })
    
    // Tratamento específico para erros de autenticação
    if (statusCode === 401) {
      // Token expirado ou inválido
      localStorage.removeItem('authToken')
      WebSocketService.disconnect()
      
      // Redirecionar para login
      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
    }
    
    return Promise.reject(error)
  }
)

export default api 